import React from "react";

const InnovativeWadahKreatifitas: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Perkembangan teknologi yang semakin pesat menghadirkan berbagai tantangan
        global, seperti perubahan iklim, keterbatasan sumber daya, serta
        kesenjangan akses pendidikan dan teknologi. Dalam konteks ini,
        generasi muda tidak lagi cukup berperan sebagai pengguna teknologi, tetapi
        dituntut menjadi pencipta solusi yang berdampak nyata.
        Kebutuhan tersebut mendorong hadirnya{" "}
        <strong>Indonesia Innovative Technology (IIT)</strong> sebagai wadah kompetisi yang mendorong pelajar menuangkan 
        kreativitas dan kemampuan teknologi untuk menjawab permasalahan dunia nyata.
      </p>

      <p>
        <strong>Innovative Technology Challenge</strong> merupakan kompetisi yang ditujukan bagi
        siswa dari jenjang Sekolah Dasar hingga gabungan SMP–SMA. 
        Peserta didorong mengembangkan solusi teknologi inovatif seiring kemajuan teknologi modern seperti kecerdasan buatan (AI), 
        Internet of Things (IoT), robotika, dan sistem otomatisasi. Dalam tim beranggotakan 2–4 orang, 
        peserta dapat merancang karya aplikatif seperti robot, unmanned aerial vehicle (UAV), smart house, 
        atau perangkat cerdas lainnya yang relevan dengan kebutuhan masyarakat.
      </p>

      <p>
        Keunikan Innovative Technology Challenge terletak pada keterkaitannya
        dengan{" "}
        <a
          href="https://sdgs.un.org/goals"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          17 Tujuan Pembangunan Berkelanjutan (Sustainable Development Goals/SDGs)
        </a>{" "}
        Pendekatan ini mendorong peserta memandang teknologi tidak hanya sebagai sarana inovasi, tetapi juga sebagai,{" "}
        <a
          href="https://www.unesco.org/en/sustainable-development/education"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          solusi berkelanjutan yang mampu memberikan dampak sosial positif.
        </a>{" "}
        Dengan mengaitkan inovasi teknologi pada isu lingkungan, kesehatan, dan ketimpangan sosial, 
        peserta diajak berpikir lebih luas dan bertanggung jawab terhadap masa depan.
      </p>

      <p>
        Proses penilaian dilakukan secara menyeluruh, mencakup kreativitas konsep, signifikansi 
        solusi, kualitas perancangan, serta dokumentasi dan presentasi. Pendekatan ini mencerminkan 
        praktik nyata di dunia riset dan inovasi, di mana ide, proses pengembangan, dan kemampuan 
        komunikasi memiliki peran penting selain hasil akhir yang dihasilkan.
      </p>

      <p>
        Melalui Innovative Technology Challenge, peserta tidak hanya mengasah keterampilan teknis 
        seperti pemrograman dan pemanfaatan sensor, tetapi juga mengembangkan{" "}
        <a
          href="https://www.weforum.org/stories/jobs-and-the-future-of-work/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          keterampilan abad ke-21
        </a>
        , termasuk berpikir kritis, kolaborasi, komunikasi, dan problem solving.
        Didukung oleh {" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , kompetisi ini menjadi langkah strategis dalam membentuk generasi muda yang kreatif, adaptif, dan siap menghadapi{" "}
        <a
          href="https://www.weforum.org/stories/jobs-and-the-future-of-work/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          tantangan teknologi masa depan.
        </a>
      </p>

      <p className="pt-4">
        👉 Cek untuk informasi lomba <a href="/iit-program?program=Innovative" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline font-medium">inovasi teknologi</a> lebih lanjut
      </p>
    </div>
  );
};

export default InnovativeWadahKreatifitas;
